<script setup>
import { useHead } from '@unhead/vue';
import BrandForm from '../../scripts/components/contactForm/BrandForm.vue';
import CarouselGeneric from '../../scripts/components/CarouselGeneric.vue';

const imagesGlob = import.meta.glob('../../images/brands/cotopaxi/products/*', { eager: true });

useHead({});

const products = [
	{
		title: "Fuego Down Vest", 
		src: imagesGlob["../../images/brands/cotopaxi/products/swaggerproductpagewebsiteproductscotopaxi3fuego-down-vest.png"].default
	},
	{
		title: "Fuego Down Jacket", 
		src: imagesGlob["../../images/brands/cotopaxi/products/swaggerproductpagewebsiteproductscotopaxi5fuego-down-jacket.png"].default
	},
	{
		title: "Luzon 18L Backpack", 
		src: imagesGlob["../../images/brands/cotopaxi/products/swaggerproductpagewebsiteproductscotopaxi2luzon-18l-backpack.png"].default
	},
	{
		title: "Amado Fleece Vest", 
		src: imagesGlob["../../images/brands/cotopaxi/products/swaggerproductpagewebsiteproductscotopaxi1amado-fleece-vest.png"].default
	},
	{
		title: "Chiquillo 30L Backpack", 
		src: imagesGlob["../../images/brands/cotopaxi/products/swaggerproductpagewebsiteproductscotopaxi6chiquillo-30l-backpack.png"].default
	},
	{
		title: "Bataan Hip Pack", 
		src: imagesGlob["../../images/brands/cotopaxi/products/swaggerproductpagewebsiteproductscotopaxi8bataan-hip-pack.png"].default
	},
	{
		title: "Del Dia Hip Pack", 
		src: imagesGlob["../../images/brands/cotopaxi/products/swaggerproductpagewebsiteproductscotopaxi4del-dia-hip-pack.png"].default
	},
	{
		title: "Abrazo Full-Zip Fleece Jacket", 
		src: imagesGlob["../../images/brands/cotopaxi/products/swaggerproductpagewebsiteproductscotopaxi9abrazo-fullzip-fleece-jacket.png"].default
	},
	{
		title: "Amado 1/2 Zip Fleece", 
		src: imagesGlob["../../images/brands/cotopaxi/products/swaggerproductpagewebsiteproductscotopaxi7amado-12-zip-fleece.png"].default
	}
]
</script>

<template lang="pug">
.page.page--brand.cotopaxi
	section.hero
		.hero__bg
		.hero__content
			.copy
				img(src='@static/images/brands/cotopaxi/logo.svg')
				h1 Custom Cotopaxi
			.image
				img(src='@static/images/brands/cotopaxi/hero.webp' alt="Person hiking into a sunset landscape wearing Cotopaxi gear, showcasing durable design built for adventure and impact.")
	section.section.section--subhero
		.section__content
			.copy
				h3 Gear for Good
				p Adventure-ready gear that stands out, holds up, and gives back at every step. Custom Cotopaxi by Swagger makes colorful, feel-good gear designed to do more than just look great. Born in the mountains and built for movement, their packs and apparel combine bold design with a bigger mission. Every piece is made to last, using recycled or repurposed materials and ethical production practices from the jump.

	.page__content
		section.section.section--products
			.section__content
				CarouselGeneric(name="productCarousel" :innerNav="false" :perPage="{ 0: 1, 751: 3 }")
					.product-card(v-for="product in products")
						.product-card__image
							img(:src="product.src" :alt="`Custom Cotopaxi ${product.title}`")
						.product-card__text
							p {{product.title}}
							

		
		section.section.section--form
			.section__content
				h2 Love this brand?<br/>Let's make something cool together
				p Please fill out this form so we can help you with your upcoming project.
				.form-wrap
					BrandForm(formName="cotopaxi")
		
		section.section.section--detail
			.stripe
				img(src='@static/images/brands/cotopaxi/banner.jpg' alt='Two smiling women in a factory holding Cotopaxi materials, highlighting ethical production and joyful craftsmanship behind the gear.')
			.section__content
				.copy
					h2 COLORFULLY CONCIOUS
					p As a certified B Corp, Cotopaxi is serious about impact. 94% of their products are made with recycled, repurposed, or responsibly sourced materials (aka their “Three Rs”). They partner with fair-wage factories, donate 1% of revenue to fight poverty, and design with circularity in mind. Bonus: no two Del Día packs are alike, so your gear is as one-of-a-kind as your next adventure.
		
		section.section.section--foot
			.bg
			.section__content

</template>

<style></style>